import React from 'react';
import SurveyForm from './form';

const SurveyNew = () => {
    return <SurveyForm />;
};

export default SurveyNew;
